// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NuOD","placeholdersHeader":"styles_placeholdersHeader__18SIj","editorStyle":"styles_editorStyle__2Fg4i","placeholdersBox":"styles_placeholdersBox__2psdo"};